// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voting-summary-group {
  border-radius: 6px;
  padding: 4px;
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
}

.voting-summary-card input[type="radio"] {
  border: 2px solid var(--ds-border);
  cursor: pointer;
}

.voting-summary-container {
  display: grid;
  grid-template-columns: 160px 1fr 160px;
  grid-template-areas: "button cards placeholder";
  min-height: 136px;
  padding-top: 4px;
}

.voting-summary-group-wrapper {
  grid-area: cards;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
}

.group-card-container {
  display: flex;
  align-items: center;
}

.summary-header.selectable {
  padding-left: 4px;
  background-color: var(--ds-background-neutral);
  width: 100%;
}

.summary-header:not(.selectable) {
  margin: 4px 0;
}

.summary-header.selectable:hover {
  background-color: var(--ds-background-neutral-hovered);
  border-radius: 3px;
  cursor: pointer;
}

.summary-header.selectable:hover > span {
  background-color: var(--ds-background-neutral-bold, #42526e);
}

.summary-header.selectable:hover > span > span {
  color: var(--ds-text-inverse, #ffffff);
}

.summary-header.selected.selectable:hover > span {
  background-color: var(--ds-background-information-bold, #0052cc);
}

button.edit-vote {
  grid-area: button;
}
`, "",{"version":3,"sources":["webpack://./src/components/game/VotingSummary/voting-summary.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".voting-summary-group {\n  border-radius: 6px;\n  padding: 4px;\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.voting-summary-card input[type=\"radio\"] {\n  border: 2px solid var(--ds-border);\n  cursor: pointer;\n}\n\n.voting-summary-container {\n  display: grid;\n  grid-template-columns: 160px 1fr 160px;\n  grid-template-areas: \"button cards placeholder\";\n  min-height: 136px;\n  padding-top: 4px;\n}\n\n.voting-summary-group-wrapper {\n  grid-area: cards;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 40px;\n}\n\n.group-card-container {\n  display: flex;\n  align-items: center;\n}\n\n.summary-header.selectable {\n  padding-left: 4px;\n  background-color: var(--ds-background-neutral);\n  width: 100%;\n}\n\n.summary-header:not(.selectable) {\n  margin: 4px 0;\n}\n\n.summary-header.selectable:hover {\n  background-color: var(--ds-background-neutral-hovered);\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.summary-header.selectable:hover > span {\n  background-color: var(--ds-background-neutral-bold, #42526e);\n}\n\n.summary-header.selectable:hover > span > span {\n  color: var(--ds-text-inverse, #ffffff);\n}\n\n.summary-header.selected.selectable:hover > span {\n  background-color: var(--ds-background-information-bold, #0052cc);\n}\n\nbutton.edit-vote {\n  grid-area: button;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
